var _circle, _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 75,
    viewBox: "0 0 51 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 25.5,
    fill: "#383838"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 25.8125C27.7949 25.8125 29.25 24.3574 29.25 22.5625C29.25 20.7676 27.7949 19.3125 26 19.3125C24.2051 19.3125 22.75 20.7676 22.75 22.5625C22.75 24.3574 24.2051 25.8125 26 25.8125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 22.5625C34.125 29.875 26 35.5625 26 35.5625C26 35.5625 17.875 29.875 17.875 22.5625C17.875 20.4076 18.731 18.341 20.2548 16.8173C21.7785 15.2935 23.8451 14.4375 26 14.4375C28.1549 14.4375 30.2215 15.2935 31.7452 16.8173C33.269 18.341 34.125 20.4076 34.125 22.5625V22.5625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44.3398,
    width: 3.77358,
    height: 30.1887,
    rx: 1.88679,
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinLocation);
export default __webpack_public_path__ + "static/media/pin_location.19753efabf879130ffb8a720777115af.svg";
export { ForwardRef as ReactComponent };